module.exports = __webpack_public_path__ + "static/media/columns.915520b0.svg";